import {
  Component,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ElementRef,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { PlantGroupElement } from 'src/app/models/O3AdministrationModels/plant-model';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { SfdcConfigurationService } from 'src/app/services/Sfdcconfiguration.service';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { RMconfigurationService } from 'src/app/services/rmconfiguration.service';
import { PageEvent } from '@angular/material/paginator';
import Swal from 'sweetalert2';
import { ManagerExecutionService } from 'src/app/services/manager.service';
import { OperatorExecutionService } from 'src/app/services/operator-execution.service';
import { CILMasterService } from 'src/app/services/cil-master-service';
import { DomSanitizer } from '@angular/platform-browser';
import * as XLSX from 'xlsx';
import { MatDialog } from '@angular/material/dialog';
import { PreventiveDialogComponent } from '../preventive-maintanance-configuration/preventive-dialog/preventive-dialog.component';
import * as _moment from 'moment';
import { CommonService } from 'src/app/services/common.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Multilingual } from 'src/app/services/multilingual';
import { log } from 'console';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { BaseApi } from 'src/backend/api/base-api';
import { EmployeeService } from 'src/backend/services/user-access-services/employee.service';
import { ButtonEditRendererComponent } from 'src/app/components/button-edit-render.components';
import { PermissionService } from 'src/backend/services/permission.service';
const moment = _moment;
@Component({
  selector: 'app-reactive-maintenance-configuration',
  templateUrl: './reactive-maintenance-configuration.component.html',
  styleUrls: ['./reactive-maintenance-configuration.component.scss'],
})
export class ReactiveMaintenanceConfigurationComponent implements OnInit {
  @ViewChild(MatTable) table!: MatTable<any>;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();
  @ViewChild('WOTypeTable') ExportWOTypeTable!: ElementRef;
  @ViewChild('WPTypeTable') ExportWPTypeTable!: ElementRef;
  @ViewChild('FailureModeTable') ExportFailureModeTable!: ElementRef;
  @ViewChild('PriorityTable') ExportPriorityTable!: ElementRef;
  @ViewChild('TimeTable') ExportTimeTable!: ElementRef;
  @ViewChild('TechnicianTable') ExportTechnicianTable!: ElementRef;

  @ViewChild('allSelected') private allSelected: any;

  formDirective: any;

  panelOpenState = false;
  WOTypeColumns: string[] = ['ID', 'Name', 'CreatedAt', 'CreatedBy', 'action'];
  WPTypeColumns: string[] = [
    'Work Premit Required',
    'Work Premit Request',
    'CreatedAt',
    'CreatedBy',
    'action',
  ];
  PriorityColumns: string[] = [
    'ID',
    'Name',
    'Color',
    'CreatedAt',
    'CreatedBy',
    'action',
  ];
  failuremodeColumns: string[] = [
    'ID',
    'Name',
    'WOType',
    'CreatedAt',
    'CreatedBy',
    'action',
  ];
  timeColumns: string[] = ['TimeLimit', 'CreatedAt', 'CreatedBy', 'action'];
  PrioritySource = new MatTableDataSource();
  WOTypeDataSource = new MatTableDataSource();
  WPTypeDataSource = new MatTableDataSource();
  breakDownConfigurationDataSource = new MatTableDataSource();
  failureModeTableDataSource = new MatTableDataSource();
  timeTableDataSource = new MatTableDataSource();
  imageSrc!: string;
  HeaderForm!: FormGroup;
  LineForm!: FormGroup;
  WOTypeForm!: FormGroup;
  PriorityForm!: FormGroup;
  MachineForm!: FormGroup;
  ComponentForm!: FormGroup;
  FailureModeForm!: FormGroup;
  TechnicianForm!: FormGroup;
  TimeForm!: FormGroup;
  updateOrderprocessingData = false;
  groupDataForm!: FormGroup;
  breakdownForm!: FormGroup;
  workPermitForm!: FormGroup;
  formMode!: boolean;
  displayComponentModal = false;
  MachineId!: any;
  plantGroupSource = new MatTreeNestedDataSource<PlantGroupElement>();
  treeControl = new NestedTreeControl<PlantGroupElement>(
    (node) => node.children
  );
  LineNode: any;
  breadcrumList!: any;
  permisson!: any;
  parameterType!: any[];
  varUnitName!: string;
  UnitNode: any;
  DivisionList: any = [];
  DepartmentList: any = [];
  user: any;
  filteredUsers: any;
  raci: any;
  opentype: any;
  edited = false;
  lineList: any = [];
  machineList: any = [];
  assemblyList: any = [];
  subAssemblyList: any = [];
  componentList: any = [];
  WOType: any = { ID: 0, Name: '', CreatedAt: new Date(), CreatedBy: 0 };
  FailureMode: any = {
    Name: '',
    WOType: '',
    CreatedAt: '',
    CreatedBy: 0,
    ID: 0,
  };
  WorkPermit: any = {
    Id: 0,
    wpRequired: '',
    wpRequest: '',
    CreatedBy: 0,
    CreatedAt: new Date(),
  };
  Priority: any = {
    ID: 0,
    Name: '',
    Color: '',
    CreatedAt: new Date(),
    CreatedBy: 0,
  };
  Technician: any = {
    ID: 0,
    RMPM: 'RM',
    Name: [],
    CreatedAt: new Date(),
    CreatedBy: 0,
  };
  Time: any = { ID: 0, TimeLimit: '', CreatedAt: '', CreatedBy: 0 };
  lineTableList: any = [];
  isEdit: boolean = false;
  newLineList: any = [];
  WOTypeList: any = [];
  WOTypeFiltList: any = [];
  PriorityList: any = [];
  TimeList: any = [];
  WPTypeList: any = [];
  WPTypeFiltList: any = [];
  iLength: number = 9;
  FailureModeList: any = [];
  pageSizeOptions = [5, 10, 20];
  pageEvent!: PageEvent;
  page = { length: 0, pageIndex: 0, pageSize: 5 };
  WOTypePage = { length: 0, pageIndex: 0, pageSize: 5 };
  WPTypePage = { length: 0, pageIndex: 0, pageSize: 5 };
  PriorityPage = { length: 0, pageIndex: 0, pageSize: 5 };
  TimePage = { length: 0, pageIndex: 0, pageSize: 5 };
  TechnicianPage = { length: 0, pageIndex: 0, pageSize: 5 };
  BreakdownConfigurationPage = { length: 0, pageIndex: 0, pageSize: 5 };
  groupId: any;
  userList: any = [];
  list: any = [];
  availableUsersList: any = [];
  orgUserList: any = [];
  TechnicianList: any = [];
  frequencyList: any;
  technicianList: any;
  plantgroup: any;
  plantgroupFormMode!: boolean;
  newGroupItemParent!: PlantGroupElement;
  addnewGroupModelTitle = '';
  isaddNewGroupItemModelVisible = false;
  filterTechnicianList: any = [];
  dialogBox: boolean = false;
  excelFile: any;
  WOTypeMasterData: any = [];
  FailureModeMasterData: any = [];
  PriorityMasterData: any = [];
  DelayTimeMasterData: any = [];
  TechnicianMasterData: any = [];
  BreakdownConfigurationMasterData: any = [];
  AllWOType: any = [];
  AllFailureMode: any = [];
  AllPriority: any = [];
  AllDelayTime: any = [];
  AllBreakDown: any = [];
  AllWPType: any = [];
  ExportWOType: any = [];
  ExportFailureMode: any = [];
  ExportPriority: any = [];
  ExportDelayTime: any = [];
  ExportTechnician: any = [];
  ExportBreakdownConfiguration: any = [];
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  lang: any;
  rowData: any = [];
  columnDefs!: any[];
  isBreakdownEdit: boolean = false;
  frameworkComponents: any;
  isAccess = ApplicationPermission.REACTIVE_MAINTENANCE_CONFIGURATION_ACCESS;
  isWrite = ApplicationPermission.REACTIVE_MAINTENANCE_CONFIGURATION_CREATE;
  isUpdate = ApplicationPermission.REACTIVE_MAINTENANCE_CONFIGURATION_UPDATE;
  isDelete = ApplicationPermission.REACTIVE_MAINTENANCE_CONFIGURATION_DELETE;
  plantSession: any;
  groupSession: any;
  userSession: any;
  gridApi: any;
  gridColumnApi: any;
  gridOptions: any = {
    CodefaultlDef: {
      rowModelType: 'infinite',
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true,
      autoHeight: true,
      minWidth: 225,
    },
    medalColumn: {
      width: 100,
      columnGroupShow: 'open',
      filter: false,
    },
    popupParent: document.querySelector('body'),
    floatingFilter: true,
  };
  WPRequestList: { ID: number; Name: string }[];
  WPrequestFiltList: { ID: number; Name: string }[];
  NewPriortyList: any;

  constructor(
    private userManagementService: UserManagementService,
    private toaster: ToastrService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,
    private platModelService: EnterPriseGroupService,
    private RMConfigurationService: RMconfigurationService,
    public datePipe: DatePipe,
    private cilMasterService: CILMasterService,
    public managerExecutionService: ManagerExecutionService,
    private sanitizer: DomSanitizer,
    private enterpriseGroupService: EnterPriseGroupService,
    private commonService: CommonService,
    private translater: TranslaterService,
    private translate: TranslateService,
    private baseApi: BaseApi,
    public dialog: MatDialog,
    private employeeService: EmployeeService,
    private permissionService: PermissionService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      event.lang === 'ar'
        ? (this.languageDir = 'rtl')
        : (this.languageDir = 'ltr');
      this.getLangWords();
    });
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'Action',
        cellRenderer: 'buttonEditRenderer',
        cellRendererParams: {
          onClick: this.onClickEdit.bind(this),
          label: 'Edit',
        },
        maxWidth: 75,
        minWidth: 50,
        cellStyle: { textAlign: 'left' },
        hide: !this.isUpdate,
        suppressMenu: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'MinorMin',
        field: 'MinorMin',
        filter: 'agTextColumnFilter',
        flex: 1,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'MinorMax',
        field: 'MinorMax',
        flex: 1,
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'ModerateMin',
        field: 'ModerateMin',
        filter: 'agTextColumnFilter',
        flex: 1,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'ModerateMax',
        field: 'ModerateMax',
        flex: 1,
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'MajorMin',
        field: 'MajorMin',
        flex: 1,
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      // {
      //   headerName: 'MajorMax',
      //   field: 'MajorMax',
      //   flex: 1,
      //   filter: 'agTextColumnFilter',
      //   headerValueGetter: this.localizeHeader.bind(this),
      // },
      {
        headerName: 'Effective StartDate',
        field: 'EffectiveStartDate',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
        valueFormatter: function (params: any) {
          return moment(params.value).format('DD/MM/YYYY hh:mm:ss a');
        },
      },
      {
        headerName: 'Effective EndDate',
        field: 'EffectiveEndDate',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
        valueFormatter: function (params: any) {
          return params.value
            ? moment(params.value).format('DD/MM/YYYY hh:mm:ss a')
            : '';
        },
      },
    ];
    this.frameworkComponents = {
      buttonEditRenderer: ButtonEditRendererComponent,
    };
  }

  TapeNameDDL!: any[];
  UnitName!: string;

  isPlantGroupModelVisible: boolean = false;
  spinnerText: string = '';

  @ViewChild('fileInput') fileInput!: ElementRef;

  isImageFile: boolean = false;
  isVideoFile: boolean = false;
  isApplicationFile: boolean = false;

  hasChild = (_: number, node: PlantGroupElement) =>
    !!node.children && node.children.length > 0;

  ngOnInit(): void {
    this.RMConfigurationService.updateAccess(this.isAccess, this.isWrite);
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.userSession = this.baseApi.getUserSession();
    this.getLangWords();
    this.user = this.userSession?.userCode;
    this.WOType.CreatedBy = this.userSession?.userCode;
    this.FailureMode.CreatedBy = this.userSession?.userCode;
    this.Priority.CreatedBy = this.userSession?.userCode;

    this.WOTypeForm = this.fb.group({
      Name: new FormControl(null, [Validators.required]),
    });
    this.PriorityForm = this.fb.group({
      Name: new FormControl(null, [Validators.required]),
      Color: new FormControl('#ff0000'),
    });
    this.FailureModeForm = this.fb.group({
      FailureMode: new FormControl(null, [Validators.required]),
      woType: new FormControl(null, [Validators.required]),
    });
    this.TechnicianForm = this.fb.group({
      Name: new FormControl(null, [Validators.required]),
    });
    this.TimeForm = this.fb.group({
      time: new FormControl(null, [Validators.required]),
    });
    this.breakdownForm = this.fb.group({
      id: new FormControl(null),
      minorMin: new FormControl(null),
      minorMax: new FormControl(null, [Validators.required]),
      moderateMin: new FormControl(null, [Validators.required]),
      moderateMax: new FormControl(null, [Validators.required]),
      majorMin: new FormControl(null, [Validators.required]),
      // majorMax: new FormControl(null),
    });
    this.workPermitForm = this.fb.group({
      wpRequired: new FormControl(null),
      wpRequest: new FormControl(null, [Validators.required]),
    });

    this.getWOType();
    this.getFailureMode();
    this.getAllPriority();
    this.getTime();
    this.getUserList();
    this.getBreakdown();
    this.getWorkPermit();
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find((x) => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
            ? 2
            : this.translate.currentLang === 'fr'
              ? 3
              : this.translate.currentLang === 'sp'
                ? 4
                : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi.refreshHeader();
      }
    });
  }

  ExportTOExcel(name: any) {
    if (this.groupSession?.groupCode && this.plantSession?.plantCode) {
      const workBook = XLSX.utils.book_new();

      this.ExportWOType =
        this.ExportWOType && this.ExportWOType.length
          ? this.ExportWOType
          : [{ ['Group']: '', ['Plant']: '', ['WO Type Name']: '' }];
      this.ExportFailureMode =
        this.ExportFailureMode && this.ExportFailureMode.length
          ? this.ExportFailureMode
          : [
            {
              ['Group']: '',
              ['Plant']: '',
              ['Failure Mode Name']: '',
              ['Work Order Type']: '',
            },
          ];
      this.ExportPriority =
        this.ExportPriority && this.ExportPriority.length
          ? this.ExportPriority
          : [{ ['Group']: '', ['Plant']: '', ['Priority Name']: '' }];
      this.ExportDelayTime =
        this.ExportDelayTime && this.ExportDelayTime.length
          ? this.ExportDelayTime
          : [{ ['Group']: '', ['Plant']: '', ['Delay Time / min']: '' }];
      this.ExportTechnician =
        this.ExportTechnician && this.ExportTechnician.length
          ? this.ExportTechnician
          : [{ ['Group']: '', ['Plant']: '', ['User Name']: '' }];
      this.ExportBreakdownConfiguration =
        this.ExportBreakdownConfiguration &&
          this.ExportBreakdownConfiguration.length
          ? this.ExportBreakdownConfiguration
          : [
            {
              ['Group']: '',
              ['Plant']: '',
              ['MinorMin']: '',
              ['MinorMax']: '',
              ['ModerateMin']: '',
              ['ModerateMax']: '',
              ['MajorMin']: '',
              // ['MajorMax']: '',
              ['EffectiveStartDate']: '',
              ['EffectiveEndDate']: '',
            },
          ];

      const WOTypeSheet = XLSX.utils.json_to_sheet(this.ExportWOType);
      const FailureModeSheet = XLSX.utils.json_to_sheet(this.ExportFailureMode);
      const PrioritySheet = XLSX.utils.json_to_sheet(this.ExportPriority);
      const TimeSheet = XLSX.utils.json_to_sheet(this.ExportDelayTime);
      const TechnicianSheet = XLSX.utils.json_to_sheet(this.ExportTechnician);
      const BreakdownConfigurationSheet = XLSX.utils.json_to_sheet(
        this.ExportBreakdownConfiguration
      );

      XLSX.utils.book_append_sheet(workBook, WOTypeSheet, 'WOType');
      XLSX.utils.book_append_sheet(workBook, FailureModeSheet, 'FailureMode');
      XLSX.utils.book_append_sheet(workBook, PrioritySheet, 'Priority');
      XLSX.utils.book_append_sheet(workBook, TimeSheet, 'Time');
      XLSX.utils.book_append_sheet(workBook, TechnicianSheet, 'Technician');
      XLSX.utils.book_append_sheet(
        workBook,
        BreakdownConfigurationSheet,
        'BreakdownConfiguration'
      );
      XLSX.writeFile(workBook, `${name}.xlsx`);
    } else {
      this.toaster.warning('Please Fill Header Fields');
      return;
    }
  }

  getWOType() {
    this.spinnerText = 'Fetching WOType Data';
    this.spinner.show();
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
      RMPM: 'RM',
    };
    this.RMConfigurationService.getWOType(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.AllWOType = res.allWoTypeList;
        this.WOTypeList = res.woTypeList;
        this.WOTypeFiltList =
          this.WOTypeList && this.WOTypeList.length
            ? this.WOTypeList.slice()
            : [];
        this.ExportWOType = [];
        if (this.WOTypeList && this.WOTypeList.length) {
          this.FailureMode.WOType = this.WOTypeFiltList[0].ID;
          for (const wotype of this.WOTypeList) {
            const ExportData = {
              ['Group']: wotype.Group.egDesc,
              ['Plant']: wotype.Plant.ptDesc,
              ['WO Type Name']: wotype.Name,
            };
            this.ExportWOType.push(ExportData);
          }
        }
        this.tableDataSetWOType(this.WOTypeList);
        this.WOTypePage.length = this.WOTypeList.length;
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(error.message);
      }
    );
  }

  getFailureMode(): void {
    this.spinnerText = 'Fetching Failure Mode Data';
    this.spinner.show();
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
    };
    this.RMConfigurationService.getFailureMode(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.AllFailureMode = res.allFailureModeList;
        this.FailureModeList = res.failureModeList;
        this.ExportFailureMode = [];
        if (this.FailureModeList && this.FailureModeList.length) {
          for (const fm of this.FailureModeList) {
            const ExportData = {
              ['Group']: fm.Group.egDesc,
              ['Plant']: fm.Plant.ptDesc,
              ['Failure Mode Name']: fm.Name,
              ['Work Order Type']: fm.WOType ? fm.WOType.Name : '',
            };
            this.ExportFailureMode.push(ExportData);
          }
        }

        this.failureModeTableDataSource = new MatTableDataSource(
          this.FailureModeList
        );
        this.page.length = this.FailureModeList.length;
        this.getPaginator(this.failureModeTableDataSource, 1);
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(error.message);
      }
    );
  }

  getAllPriority() {
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
    };
    this.spinnerText = 'Fetching Priority Data';
    this.spinner.show();
    this.RMConfigurationService.getPriority(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.AllPriority = res.allPriorityList;
        this.PriorityList = res.priorityList;
        this.ExportPriority = [];
        if (this.PriorityList && this.PriorityList.length) {
          for (const pri of this.PriorityList) {
            const ExportData = {
              ['Group']: pri.Group.egDesc,
              ['Plant']: pri.Plant.ptDesc,
              ['Priority Name']: pri.Name,
            };
            this.ExportPriority.push(ExportData);
          }
        }
        this.tableDataSetPriority(this.PriorityList);
        this.PriorityPage.length = this.PriorityList.length;
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(error.message);
      }
    );
  }

  getTime(): void {
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
    };
    this.spinnerText = 'Fetching Time Data';
    this.spinner.show();
    this.RMConfigurationService.getTime(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.AllDelayTime = res.allTimeList;
        this.TimeList = res.timeList;
        this.ExportDelayTime = [];
        if (this.TimeList && this.TimeList.length) {
          for (const time of this.TimeList) {
            const ExportData = {
              ['Group']: time.Group.egDesc,
              ['Plant']: time.Plant.ptDesc,
              ['Delay Time / min']: time.TimeLimit,
            };
            this.ExportDelayTime.push(ExportData);
          }
        }
        this.timeTableDataSource = new MatTableDataSource(this.TimeList);
        this.getPaginator(this.timeTableDataSource, 3);
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(error.message);
      }
    );
  }

  getAllTechnician() {
    this.spinnerText = 'Fetching Technician Data';
    this.spinner.show();
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
      RMPM: 'RM',
    };
    this.RMConfigurationService.getTechnician(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.TechnicianList = res.data;
        this.Technician.Name = [];
        this.ExportTechnician = [];
        this.availableUsersList = this.orgUserList;
        this.userList = [...this.availableUsersList];
        for (let tech of this.TechnicianList) {
          const user = this.userList.find(
            (user: any) => user.employeeCode == tech.UserId
          );
          if (user) {
            tech.UserName = user.fullName;
            let check;
            if (this.Technician?.Name?.length) {
              check = this.Technician.Name.find(
                (user: any) => user == tech.UserId
              );
              if (!check) {
                this.Technician.Name.push(tech.UserId);
                const ExportData = {
                  ['Group']: tech.Group.egDesc,
                  ['Plant']: tech.Plant.ptDesc,
                  ['User Name']: tech.UserName,
                };
                this.ExportTechnician.push(ExportData);
              }
            } else {
              this.Technician.Name.push(tech.UserId);
              const ExportData = {
                ['Group']: tech.Group.egDesc,
                ['Plant']: tech.Plant.ptDesc,
                ['User Name']: tech.UserName,
              };
              this.ExportTechnician.push(ExportData);
            }
          }
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(error.message);
      }
    );
  }

  getBreakdown() {
    const key = {
      PlantId: this.plantSession?.plantCode,
    };
    this.spinner.show();
    this.RMConfigurationService.getBreakdown(key).subscribe(
      (res: any) => {
        this.rowData = res.BreakdownList;
        this.AllBreakDown = res.BreakdownList.slice();
        this.ExportBreakdownConfiguration = [];
        if (this.AllBreakDown && this.AllBreakDown.length) {
          for (const bdtype of this.AllBreakDown) {
            const ExportData = {
              ['Group']: this.groupSession?.groupName,
              ['Plant']: this.plantSession?.plantName,
              ['MinorMin']: bdtype.MinorMin,
              ['MinorMax']: bdtype.MinorMax,
              ['ModerateMin']: bdtype.ModerateMin,
              ['ModerateMax']: bdtype.ModerateMax,
              ['MajorMin']: bdtype.MajorMin,
               ['MajorMax']: 0,
              ['EffectiveStartDate']: bdtype.EffectiveStartDate,
              ['EffectiveEndDate']: bdtype.EffectiveEndDate,
            };
            this.ExportBreakdownConfiguration.push(ExportData);
          }
        }
        this.tableDataSetBreakdownConfiguration(this.AllBreakDown);
        this.BreakdownConfigurationPage.length = this.AllBreakDown.length;
        this.spinner.hide();
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(error.message);
      }
    );
  }

  getWorkPermit() {
    this.spinnerText = 'Fetching Work Permit Data';
    this.spinner.show();
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
      RMPM: 'RM',
    };
    const WorkPermitRequestHardCodedlist = [
      { ID: 0, Name: 'Others' },
      { ID: 1, Name: 'HODHOD' },
    ];
    this.WPRequestList = WorkPermitRequestHardCodedlist.slice();
    this.WPrequestFiltList = WorkPermitRequestHardCodedlist.slice();
    // this.RMConfigurationService.getWorkPermit(data).subscribe(
    //   (res: any) => {
    //     this.spinner.hide();
    //     this.AllWPType = res.allWPTypeList;
    //     this.WPTypeList = res.wpTypeList;
    //     this.WPTypeFiltList = this.WPTypeList && this.WPTypeList.length ? this.WPTypeList.slice() : [];
    //     this.ExportWOType = [];
    //     if (this.WPTypeList && this.WPTypeList.length) {
    //       this.FailureMode.WOType = this.WPTypeFiltList[0].ID;
    //       for (const wptype of this.WPTypeList) {
    //         const ExportData = {
    //           ['Group']: wptype.Group.egDesc,
    //           ['Plant']: wptype.Plant.ptDesc,
    //           ['Work Permit Required']: wptype.WorkPermitRequired,
    //         };
    //         this.ExportWOType.push(ExportData);
    //       }
    //     }
    //     this.tableDataSetWOType(this.WOTypeList);
    //     this.WOTypePage.length = this.WOTypeList.length;
    //   },
    //   (error: any) => {
    //     this.spinner.hide();
    //     this.toaster.error('Error', error.message);
    //   }
    // );
  }

  applyWOTypeFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.WOTypeDataSource.filter = filterValue.trim().toLowerCase();

    if (this.WOTypeDataSource.paginator) {
      this.WOTypeDataSource.paginator.firstPage();
    }
  }

  applyWPTypeFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.WPTypeDataSource.filter = filterValue.trim().toLowerCase();

    if (this.WPTypeDataSource.paginator) {
      this.WPTypeDataSource.paginator.firstPage();
    }
  }

  applyBreakdownConfigurationFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.breakDownConfigurationDataSource.filter = filterValue
      .trim()
      .toLowerCase();

    if (this.breakDownConfigurationDataSource.paginator) {
      this.breakDownConfigurationDataSource.paginator.firstPage();
    }
  }

  applyFailureFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.failureModeTableDataSource.filter = filterValue.trim().toLowerCase();

    if (this.failureModeTableDataSource.paginator) {
      this.failureModeTableDataSource.paginator.firstPage();
    }
  }

  applyPriorityFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.PrioritySource.filter = filterValue.trim().toLowerCase();

    if (this.PrioritySource.paginator) {
      this.PrioritySource.paginator.firstPage();
    }
  }

  applyTimeFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.timeTableDataSource.filter = filterValue.trim().toLowerCase();

    if (this.timeTableDataSource.paginator) {
      this.timeTableDataSource.paginator.firstPage();
    }
  }

  editWOType(element: any) {
    this.WOType.ID = element.ID;
    this.WOType.Name = element.Name;
    this.isEdit = true;
  }

  editWPType(element: any) {
    this.WorkPermit.Id = element.Id;
    this.WorkPermit.wpRequired = element.WorkPermitRequired;
    this.WorkPermit.wpRequest = element.WorkPermitRequest;
    this.isEdit = true;
  }

  editFailureRow(element: any) {
    this.edited = true;
    this.FailureMode.ID = element.ID;
    this.FailureMode.Name = element.Name;
    this.FailureMode.WOType = element.WOType ? element.WOType.ID : '';
  }

  editPriority(element: any) {
    this.Priority.ID = element.ID;
    this.Priority.Name = element.Name;
    this.PriorityForm.get('Color')?.setValue(element.Color);
    this.Priority.Color = element.Color;
    this.isEdit = true;
    this.NewPriortyList = this.PriorityList.slice();
    const indexToRemove = this.NewPriortyList.findIndex(
      (x) => x.Name.toLowerCase() === this.Priority.Name.toLowerCase() && x.Color === this.Priority.Color
    );
    if (indexToRemove !== -1) {
      this.NewPriortyList.splice(indexToRemove, 1);
    }
  }

  editTimeRow(element: any) {
    this.edited = true;
    this.Time.ID = element.ID;
    this.Time.TimeLimit = element.TimeLimit;
  }

  deleteWOType(element: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete WOType!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        const data = {
          ID: element.ID,
          CreatedBy: element.CreatedBy,
        };
        this.RMConfigurationService.deleteWOType(data).subscribe(
          (success) => {
            if (success.status == true) {
              this.toaster.success(success.message, null, {
                timeOut: 3000,
              });
            } else {
              this.toaster.warning(success.message, null, {
                timeOut: 3000,
              });
            }

            this.spinner.hide();
            this.getWOType();
          },
          (error) => {
            this.spinner.hide();
            this.toaster.error(error.error.message);
          }
        );
      }
      this.isEdit = false;
    });
  }

  deleteWPType(element: any) {
    // Swal.fire({
    //   title: 'Are you sure?',
    //   text: 'You want to delete Work Permit!',
    //   icon: 'warning',
    //   showCancelButton: true,
    //   confirmButtonText: 'Yes',
    //   cancelButtonText: 'No',
    // }).then((result) => {
    //   if (result.value) {
    //     this.spinner.show();
    //     const data = {
    //       ID: element.ID,
    //       CreatedBy: element.CreatedBy,
    //     };
    //     this.RMConfigurationService.deleteWorkPermit(data).subscribe(
    //       (success) => {
    //         if (success.status == true) {
    //           this.toaster.success(success.message, 'Success', {
    //             timeOut: 3000,
    //           });
    //         } else {
    //           this.toaster.warning(success.message, 'Warning', {
    //             timeOut: 3000,
    //           });
    //         }
    //         this.spinner.hide();
    //         this.getWOType();
    //       },
    //       (error) => {
    //         this.spinner.hide();
    //         this.toaster.error('Error', error.error.message);
    //       }
    //     );
    //   }
    //   this.isEdit = false;
    // });
  }

  deleteFailureRow(element: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete FailureMode!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        const data = {
          ID: element.ID,
        };
        this.RMConfigurationService.deleteFailureMode(data).subscribe(
          (success) => {
            if (success.status == true) {
              this.toaster.success(success.message, null, {
                timeOut: 3000,
              });
            } else {
              this.toaster.warning(success.message, null, {
                timeOut: 3000,
              });
            }
            this.spinner.hide();
            this.getFailureMode();
          },
          (error) => {
            this.spinner.hide();
            this.toaster.error(error.error.message);
          }
        );
      }
      this.edited = false;
    });
  }

  deletePriority(element: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete Priority!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.RMConfigurationService.deletePriority(element).subscribe(
          (success) => {
            if (success.status == true) {
              this.toaster.success(success.message, null, {
                timeOut: 3000,
              });
            } else {
              this.toaster.warning(success.message, null, {
                timeOut: 3000,
              });
            }
            this.spinner.hide();
            this.getAllPriority();
          },
          (error) => {
            this.spinner.hide();
            this.toaster.error(error.error.message);
          }
        );
      }
      this.isEdit = false;
    });
  }

  WOTypeSubmit(formDirective: FormGroupDirective) {
    if (this.WOTypeForm.status == 'INVALID') {
      this.toaster.warning('Please Fill All Required Fields');
      return;
    } else {
      this.formDirective = formDirective;
      this.WOType.CreatedAt = new Date();
      this.WOType.CreatedBy = this.userSession?.userCode;
      this.WOType.RMPM = 'RM';
      const dataGroupPlant = {
        Group: this.groupSession?.groupCode,
        Plant: this.plantSession?.plantCode,
      };
      const data = {
        Data: this.WOType,
        HeaderData: dataGroupPlant,
      };
      if (!this.isEdit) {
        const chkWOType = this.WOTypeList.find((wo: any) => {
          const a = wo.Name.toLowerCase();
          const b = this.WOType.Name.toLowerCase();
          return a == b;
        });
        if (chkWOType) {
          this.toaster.warning('This WOType Already Exist');
          return;
        }
        this.RMConfigurationService.addWOType(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.WOTypeForm.reset();
            this.isEdit = false;
            if (res.status) {
              this.toaster.success(res.message);
              this.formDirective.resetForm();
              this.WOTypeForm.reset();
              this.getWOType();
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error(error.message);
          }
        );
      } else {
        const chkWOType = this.WOTypeList.find(
          (x) => x.Name.toLowerCase() === this.WOType.Name.toLowerCase()
        );

        if (chkWOType) {
          this.toaster.warning('This WOType Already Exist');
          return;
        }
        this.RMConfigurationService.updateWOType(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.WOTypeForm.reset();
            this.isEdit = false;
            if (res.status) {
              this.toaster.success(res.message);
              this.formDirective.resetForm();
              this.WOTypeForm.reset();
              this.getWOType();
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error(error.message);
          }
        );
      }
    }
  }

  FailureModeOnSubmit(formDirective: FormGroupDirective) {
    if (this.FailureModeForm.invalid) {
      this.toaster.warning('Please Fill All Required Fields');
      return;
    } else {
      this.formDirective = formDirective;
      this.FailureMode.CreatedAt = new Date();
      this.FailureMode.CreatedBy = this.userSession?.userCode;
      const dataGroupPlant = {
        Group: this.groupSession?.groupCode,
        Plant: this.plantSession?.plantCode,
      };
      const data = {
        Data: this.FailureMode,
        HeaderData: dataGroupPlant,
      };
      if (!this.edited) {
        const chkFailureMode = this.FailureModeList.find((fm: any) => {
          const a = fm.Name.toLowerCase();
          const b = this.FailureMode.Name.toLowerCase();
          return a == b && this.FailureMode.WOType == fm.WOType.ID;
        });
        if (chkFailureMode) {
          this.toaster.warning('This FailureMode Already Exist');
          return;
        }
        this.RMConfigurationService.addFailureMode(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.formDirective.resetForm();
            this.FailureModeForm.reset();
            this.edited = false;
            if (res.status) {
              this.toaster.success(res.message);
              this.getFailureMode();
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error(error.message);
          }
        );
      } else {
        const chkFailureMode = this.FailureModeList.find(
          (x) => x.Name.toLowerCase() === this.FailureMode.Name.toLowerCase()
        );

        if (chkFailureMode) {
          this.toaster.warning('This FailureMode Already Exist');
          return;
        }
        this.RMConfigurationService.updateFailureMode(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.formDirective.resetForm();
            this.FailureModeForm.reset();
            this.edited = false;
            if (res.status) {
              this.toaster.success(res.message);
              this.getFailureMode();
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error(error.message);
          }
        );
      }
      this.formDirective.resetForm();
      this.FailureModeForm.reset();
    }
  }

  PrioritySubmit(formDirective: FormGroupDirective) {
    if (this.PriorityForm.status == 'INVALID') {
      this.toaster.warning('Please Fill All Required Fields');
      return;
    } else {
      this.formDirective = formDirective;
      const color = this.PriorityForm.value.Color;
      this.Priority.CreatedAt = new Date();
      this.Priority.CreatedBy = this.userSession?.userCode;
      this.Priority.Color = color == null ? '#ff0000' : color;
      const dataGroupPlant = {
        Group: this.groupSession?.groupCode,
        Plant: this.plantSession?.plantCode,
      };
      const data = {
        Data: this.Priority,
        HeaderData: dataGroupPlant,
      };
      if (!this.isEdit) {
        const chkPriority = this.PriorityList.find((pri: any) => {
          const a = pri.Name.toLowerCase();
          const b = this.Priority.Name.toLowerCase();
          return a == b;
        });
        if (chkPriority) {
          this.toaster.warning('This Priority Already Exist');
          return;
        }
        this.RMConfigurationService.addPriority(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.PriorityForm.reset();
            this.isEdit = false;
            if (res.status) {
              this.toaster.success(res.message);
              this.formDirective.resetForm();
              this.PriorityForm.reset();
              this.getAllPriority();
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error(error.message);
          }
        );
      } else {
        const chkWOType = this.NewPriortyList.find(
          (x) => x.Name.toLowerCase() === this.Priority.Name.toLowerCase()
        );

        if (chkWOType) {
          this.toaster.warning('This Priority Already Exist');
          return;
        }
        this.RMConfigurationService.updatePriority(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.PriorityForm.reset();
            this.isEdit = false;
            if (res.status) {
              this.toaster.success(res.message);
              this.formDirective.resetForm();
              this.PriorityForm.reset();
              this.getAllPriority();
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error(error.message);
          }
        );
      }
    }
  }

  TimeOnSubmit(formDirective: FormGroupDirective) {
    if (this.TimeForm.invalid) {
      this.toaster.warning('Please Fill All Required Fields');
      return;
    } else if (this.Time.TimeLimit <= 0) {
      this.toaster.warning(
        'Minimum Delayed Time Value Is 1 Minutes'
      );
      return;
    } else {
      this.formDirective = formDirective;
      this.Time.CreatedAt = new Date();
      this.Time.CreatedBy = this.userSession?.userCode;
      const dataGroupPlant = {
        Group: this.groupSession?.groupCode,
        Plant: this.plantSession?.plantCode,
      };
      const data = {
        Data: this.Time,
        HeaderData: dataGroupPlant,
      };

      if (!this.edited) {
        if (this.TimeList && this.TimeList.length) {
          this.toaster.warning('Delay Time Already Exist');
          return;
        }
        this.RMConfigurationService.addTime(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.edited = false;
            if (res.status) {
              this.toaster.success(res.message);
              this.formDirective.resetForm();
              this.TimeForm.reset();
              this.getTime();
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error(error.message);
          }
        );
      } else {
        this.RMConfigurationService.updateTime(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.edited = false;
            if (res.status) {
              this.toaster.success(res.message);
              this.formDirective.resetForm();
              this.TimeForm.reset();
              this.getTime();
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error(error.message);
          }
        );
      }
    }
  }

  TechnicianSubmit() {
    const index: number = this.Technician.Name.indexOf('ALL');
    if (index !== -1) {
      this.Technician.Name.splice(index, 1);
    }
    this.Technician.CreatedAt = new Date();
    this.Technician.CreatedBy = this.userSession?.userCode;
    const dataGroupPlant = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
    };
    const data = {
      Data: this.Technician,
      HeaderData: dataGroupPlant,
    };

    if (this.Technician.Name.length == 0) {
      this.toaster.warning('Select Atleast one technician');
      return;
    }
    this.RMConfigurationService.addTechnician(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.toaster.success(res.message);
          this.getAllTechnician();
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(error.message);
      }
    );
  }

  getPaginator(dataSource: MatTableDataSource<any>, index: number): void {
    setTimeout(() => {
      dataSource.paginator = this.paginator.toArray()[index];
      dataSource.sort = this.sort.toArray()[index];
    }, 100);
  }

  customePaginator(event: any, name: any) {
    if (name == 'failuremode') {
      this.page.pageIndex = event.pageIndex;
      this.page.pageSize = event.pageSize;
    } else if (name == 'wotype') {
      this.WOTypePage.pageIndex = event.pageIndex;
      this.WOTypePage.pageSize = event.pageSize;
    } else if (name == 'priority') {
      this.PriorityPage.pageIndex = event.pageIndex;
      this.PriorityPage.pageSize = event.pageSize;
    } else if (name == 'time') {
      this.TimePage.pageIndex = event.pageIndex;
      this.TimePage.pageSize = event.pageSize;
    } else if (name == 'breakdownConfiguration') {
      this.BreakdownConfigurationPage.pageIndex = event.pageIndex;
      this.BreakdownConfigurationPage.pageSize = event.pageSize;
    } else if (name == 'wptype') {
      this.WPTypePage.pageIndex = event.pageIndex;
      this.WPTypePage.pageSize = event.pageSize;
    }
  }

  openFile() {

    this.fileInput.nativeElement.click();
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  replaceIcon(value: any): any {
    return value.replace(/(<([^>]+)>)/gi, '');
  }

  replaceString(value: any): any {
    const data = value.split('"')[1];
    if (data === 'IsOptionalplanticon') {
      return true;
    } else {
      return false;
    }
  }

  closePlantGroupModel(): void {
    this.updateOrderprocessingData = false;
  }

  collapseAllNode(): void {
    this.treeControl.collapseAll();
  }

  expandAllNode(): void {
    this.treeControl.expandAll();
  }

  openedChange(opened: boolean): void {
    this.opentype = opened ? 'opened' : 'closed';
    this.getUserList();
  }

  getUserList() {
    this.spinnerText = 'Fetching User Data';
    this.employeeService.getAllEmployees().subscribe(
      (res: any) => {
        if (res) {
          this.orgUserList = res;
          this.raci = this.orgUserList.slice();
          this.filteredUsers = this.orgUserList.slice();

          if (this.opentype == 'closed') {
            this.spinner.hide();
          } else if (this.opentype == 'opened') {
            this.spinner.hide();
          } else {
            this.getAllTechnician();
          }
        } else {
          this.orgUserList = [];
          this.availableUsersList = [...this.orgUserList];

          this.userList = [...this.availableUsersList];
          this.spinner.hide();
        }
      },
      (err: any) => {
        console.log(err);
        this.spinner.hide();
      }
    );
  }

  setUserName(val: any) {
    if (this.userList && this.userList.length) {
      const CreatedBy = this.userList.find((usr: any) => usr.id == val);
      return CreatedBy ? CreatedBy.fullName : '';
    }
  }

  searchValues(filter: any) {
    filter = filter.target.value;
    const selectedValues = [];
    this.userList = this.availableUsersList.filter((user: any) => {
      let lowerCase = user.fullName.toLocaleLowerCase();
      return user.fullName.startsWith(filter) || lowerCase.startsWith(filter);
    });
  }

  openTreeModal(): void {
    const key = {
      PlantCode: this.plantSession?.plantCode,
      GroupCode: this.groupSession?.groupCode,
      UserCode: this.userSession?.userCode,
      div_Id: '',
      level: 'Plant',
      CreatedBy: this.userSession?.userCode,
      IsOptional: 0,
    };
    this.spinner.show();
    this.spinnerText = 'Fetching Tree Data';
    this.enterpriseGroupService.getTreeModal(key).subscribe(
      (data: any) => {
        this.spinner.hide();
        if (!this.dialogBox) {
          this.updateOrderprocessingData = true;
          const plantGroupData: PlantGroupElement[] = data.TreeModalList;
          this.plantGroupSource.data = plantGroupData;
          this.udpateNodeParentDetails();
          this.treeControl.dataNodes = this.plantGroupSource.data;
          this.isPlantGroupModelVisible = true;
        } else {
          this.plantGroupSource.data = data.TreeModalList;
          this.udpateNodeParentDetails();
          this.dialogBox = false;
        }
      },
      (error: any) => {
        this.toaster.error(error.message);
      }
    );
  }

  udpateNodeParentDetails() {
    if (this.plantGroupSource.data && this.plantGroupSource.data.length) {
      this.plantGroupSource.data.forEach((group, groupIndex) => {
        if (group.children && group.children.length) {
          group.children.forEach((plant, plantIndex) => {
            plant.groupName = group.text;
            plant.groupId = group.PrimaryId;
            if (plant.children && plant.children.length) {
              plant.children.forEach((division: any, divisionIndex: number) => {
                division.plantId = plant.PrimaryId;
                division.plantName = plant.text;
                division.groupName = group.text;
                division.groupId = group.PrimaryId;
                if (division.children && division.children.length) {
                  division.children.forEach(
                    (department: any, departmentIndex: number) => {
                      department.divisionId = division.PrimaryId;
                      department.divisionName = division.text;
                      department.plantId = plant.PrimaryId;
                      department.plantName = plant.text;
                      department.groupId = group.PrimaryId;
                      department.groupName = group.text;
                      if (department.children && department.children.length) {
                        department.children.forEach((line: any) => {
                          line.departmentId = department.PrimaryId;
                          line.departmentName = department.text;
                          line.divisionId = division.PrimaryId;
                          line.divisionName = division.text;
                          line.plantId = plant.PrimaryId;
                          line.plantName = plant.text;
                          line.groupId = group.PrimaryId;
                          line.groupName = group.text;
                          if (line.children && line.children.length) {
                            line.children.forEach((unit: any) => {
                              unit.lineId = line.PrimaryId;
                              unit.lineName = line.text;
                              unit.departmentId = department.PrimaryId;
                              unit.departmentName = department.text;
                              unit.divisionId = division.PrimaryId;
                              unit.divisionName = division.text;
                              unit.plantId = plant.PrimaryId;
                              unit.plantName = plant.text;
                              unit.groupId = group.PrimaryId;
                              unit.groupName = group.text;
                              if (unit.children && unit.children.length) {
                                unit.children.forEach((assembly: any) => {
                                  assembly.unitName = unit.text;
                                  assembly.unitId = unit.PrimaryId;
                                  assembly.lineId = line.PrimaryId;
                                  assembly.lineName = line.text;
                                  assembly.departmentId = department.PrimaryId;
                                  assembly.departmentName = department.text;
                                  assembly.divisionId = division.PrimaryId;
                                  assembly.divisionName = division.text;
                                  assembly.plantId = plant.PrimaryId;
                                  assembly.plantName = plant.text;
                                  assembly.groupId = group.PrimaryId;
                                  assembly.groupName = group.text;
                                  if (
                                    assembly.children &&
                                    assembly.children.length
                                  ) {
                                    assembly.children.forEach(
                                      (subAssembly: any) => {
                                        subAssembly.assemblyName =
                                          assembly.text;
                                        subAssembly.assemblyId =
                                          assembly.PrimaryId;
                                        subAssembly.unitName = unit.text;
                                        subAssembly.unitId = unit.PrimaryId;
                                        subAssembly.lineId = line.PrimaryId;
                                        subAssembly.lineName = line.text;
                                        subAssembly.departmentId =
                                          department.PrimaryId;
                                        subAssembly.departmentName =
                                          department.text;
                                        subAssembly.divisionId =
                                          division.PrimaryId;
                                        subAssembly.divisionName =
                                          division.text;
                                        subAssembly.plantId = plant.PrimaryId;
                                        subAssembly.plantName = plant.text;
                                        subAssembly.groupId = group.PrimaryId;
                                        subAssembly.groupName = group.text;
                                        if (
                                          subAssembly.children &&
                                          subAssembly.children.length
                                        ) {
                                          subAssembly.children.forEach(
                                            (component: any) => {
                                              component.subAssemblyName =
                                                subAssembly.text;
                                              component.subAssemblyId =
                                                subAssembly.PrimaryId;
                                              component.assemblyName =
                                                assembly.text;
                                              component.assemblyId =
                                                assembly.PrimaryId;
                                              component.unitName = unit.text;
                                              component.unitId = unit.PrimaryId;
                                              component.lineId = line.PrimaryId;
                                              component.lineName = line.text;
                                              component.departmentId =
                                                department.PrimaryId;
                                              component.departmentName =
                                                department.text;
                                              component.divisionId =
                                                division.PrimaryId;
                                              component.divisionName =
                                                division.text;
                                              component.plantId =
                                                plant.PrimaryId;
                                              component.plantName = plant.text;
                                              component.groupId =
                                                group.PrimaryId;
                                              component.groupName = group.text;
                                            }
                                          );
                                        }
                                      }
                                    );
                                  }
                                });
                              }
                            });
                          }
                        });
                      }
                    }
                  );
                }
              });
            }
          });
        }
      });
    }
  }

  openDialog(name: any): void {
    if (this.groupSession?.groupCode && this.plantSession?.plantCode) {
      this.dialogBox = true;
      this.openTreeModal();
      let dialogRef = this.dialog.open(PreventiveDialogComponent, {
        disableClose: true,
        width: '500px',
        data: { moduleName: name },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result == undefined) {
        } else {
          this.excelFile = result;
          this.validateExcelData();
        }
      });
    } else {
      this.toaster.warning('Please Fill Header Fields');
      return;
    }
  }

  validateExcelData() {
    var WORow = 1;
    var PriRow = 1;
    var DTRow = 1;
    var TechRow = 1;
    var BDRow = 1;

    if (
      this.excelFile &&
      this.excelFile.WOType &&
      this.excelFile.WOType.length
    ) {
      for (let obj of this.excelFile.WOType) {
        if (!obj['Group']) {
          if (!obj['Group']) {
            this.toaster.error(
              `Group can't be empty on row ${WORow} in Work Order Type Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }

          this.excelFile = [];
          this.WOTypeMasterData = [];
          return;
        } else if (!obj['Plant']) {
          if (!obj['Plant']) {
            this.toaster.error(
              `Plant can't be empty on row ${WORow} in Work Order Type Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }

          this.excelFile = [];
          this.WOTypeMasterData = [];
          return;
        } else if (!obj['WO Type Name']) {
          if (!obj['WO Type Name']) {
            this.toaster.error(
              `WO Type can't be empty on row ${WORow} in Work Order Type Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }

          this.excelFile = [];
          this.WOTypeMasterData = [];
          return;
        } else {
          let groupobj: any;
          let plantobj: any;
          let uniqueData: any;
          let existXLData: any;

          const WOTypeData: any = {
            Group: this.groupSession?.groupCode,
            Plant: this.plantSession?.plantCode,
            Name: '',
            CreatedAt: '',
            CreatedBy: '',
          };

          if (
            this.groupSession?.groupName.trim().toLowerCase() ===
            obj['Group'].trim().toLowerCase()
          ) {
            if (
              this.plantSession?.plantName.trim().toLowerCase() ===
              obj['Plant'].trim().toLowerCase()
            ) {
              uniqueData = this.AllWOType.find((wo: any) => {
                const a = String(obj['WO Type Name'] || '').trim().toLowerCase();
                const b = String(wo.Name || '').trim().toLowerCase();

                return (
                  wo.Group &&
                  wo.Group.egId == WOTypeData.Group &&
                  wo.Plant &&
                  wo.Plant.ptId == WOTypeData.Plant &&
                  a == b
                );
              });

              if (!uniqueData)
                WOTypeData.Name = obj['WO Type Name'];
            }
            else {
              this.toaster.error(
                `Plant ${obj['Plant']} not found in database on row ${WORow} in Work Order Type Sheet`,
                null,
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.WOTypeMasterData = [];
              return;
            }
          } else {
            this.toaster.error(
              `Group ${obj['Group']} not found in database on row ${WORow} in Work Order Type Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
            this.excelFile = [];
            this.WOTypeMasterData = [];
            return;
          }

          WOTypeData.CreatedAt = new Date();
          WOTypeData.CreatedBy = this.userSession?.userCode;

          if (WORow != 1) {
            existXLData = this.WOTypeMasterData.find((wo: any) => {
              return (
                wo.Name == WOTypeData.Name &&
                wo.Group == WOTypeData.Group &&
                wo.Plant == WOTypeData.Plant
              );
            });
          }
          if (!uniqueData && !existXLData)
            this.WOTypeMasterData.push(WOTypeData);
        }
        WORow++;
      }
    }

    if (
      this.excelFile &&
      this.excelFile.Priority &&
      this.excelFile.Priority.length
    ) {
      for (let obj of this.excelFile.Priority) {
        if (!obj['Group']) {
          if (!obj['Group']) {
            this.toaster.error(
              `Group can't be empty on row ${PriRow} in Priority Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          return;
        } else if (!obj['Plant']) {
          if (!obj['Plant']) {
            this.toaster.error(
              `Plant can't be empty on row ${PriRow} in Priority Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          return;
        } else if (!obj['Priority Name']) {
          if (!obj['Priority Name']) {
            this.toaster.error(
              `Priority Name can't be empty on row ${PriRow} in Priority Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          return;
        } else {
          let groupobj: any;
          let plantobj: any;
          let uniqueData: any;
          let existXLData: any;

          const PriorityData: any = {
            Group: this.groupSession?.groupCode,
            Plant: this.plantSession?.plantCode,
            Name: '',
            CreatedAt: '',
            CreatedBy: '',
          };

          if (
            this.groupSession?.groupName.trim().toLowerCase() ===
            obj['Group'].trim().toLowerCase()
          ) {
            if (
              this.plantSession?.plantName.trim().toLowerCase() ===
              obj['Plant'].trim().toLowerCase()
            ) {
              uniqueData = this.AllPriority.find((pri: any) => {
                const a = obj['Priority Name'].trim().toLowerCase();
                const b = pri.Name.trim().toLowerCase();
                return (
                  pri.Group &&
                  pri.Group.egId == PriorityData.Group &&
                  pri.Plant &&
                  pri.Plant.ptId == PriorityData.Plant &&
                  a == b
                );
              });
              if (!uniqueData) PriorityData.Name = obj['Priority Name'];
            } else {
              this.toaster.error(
                `Plant ${obj['Plant']} not found in database on row ${PriRow} in Priority Sheet`,
                null,
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.WOTypeMasterData = [];
              this.FailureModeMasterData = [];
              this.PriorityMasterData = [];
              return;
            }
          } else {
            this.toaster.error(
              `Group ${obj['Group']} not found in database on row ${PriRow} in Priority Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
            this.excelFile = [];
            this.WOTypeMasterData = [];
            this.FailureModeMasterData = [];
            this.PriorityMasterData = [];
            return;
          }

          PriorityData.CreatedAt = new Date();
          PriorityData.CreatedBy = this.userSession?.userCode;

          if (PriRow != 1) {
            existXLData = this.PriorityMasterData.find((pri: any) => {
              return (
                pri.Name == PriorityData.Name &&
                pri.Group == PriorityData.Group &&
                pri.Plant == PriorityData.Plant
              );
            });
          }
          if (!uniqueData && !existXLData)
            this.PriorityMasterData.push(PriorityData);
        }
        PriRow++;
      }
    }

    if (
      this.excelFile &&
      this.excelFile.DelayTime &&
      this.excelFile.DelayTime.length
    ) {
      for (let obj of this.excelFile.DelayTime) {
        if (!obj['Group']) {
          if (!obj['Group']) {
            this.toaster.error(
              `Group can't be empty on row ${DTRow} DelayTime Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          return;
        } else if (!obj['Plant']) {
          if (!obj['Plant']) {
            this.toaster.error(
              `Plant can't be empty on row ${DTRow} DelayTime Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          return;
        } else if (
          !obj['Delay Time / min'] ||
          typeof obj['Delay Time / min'] != 'number'
        ) {
          if (!obj['Delay Time / min']) {
            this.toaster.error(
              `Delay Time can't be empty on row ${DTRow} DelayTime Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
            this.excelFile = [];
            this.WOTypeMasterData = [];
            this.FailureModeMasterData = [];
            this.PriorityMasterData = [];
            this.DelayTimeMasterData = [];
            return;
          }
          if (typeof obj['Delay Time / min'] != 'number') {
            this.toaster.error(
              `Delay Time should be a number on row ${DTRow} DelayTime Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          return;
        } else {
          let groupobj: any;
          let plantobj: any;
          let uniqueData: any;
          let existXLData: any;

          const TimeData: any = {
            Group: this.groupSession?.groupCode,
            Plant: this.plantSession?.plantCode,
            TimeLimit: '',
            CreatedAt: '',
            CreatedBy: '',
          };

          if (
            this.groupSession?.groupName.trim().toLowerCase() ===
            obj['Group'].trim().toLowerCase()
          ) {
            if (
              this.plantSession?.plantName.trim().toLowerCase() ===
              obj['Plant'].trim().toLowerCase()
            ) {
              uniqueData = this.AllDelayTime.find(
                (time: any) =>
                  time.Group &&
                  time.Group.egId == TimeData.Group &&
                  time.Plant &&
                  time.Plant.ptId == TimeData.Plant
              );
              if (obj['Delay Time / min'] <= 0) {
                this.toaster.error(
                  `Minimum Delayed Time Value Is 1 on row ${DTRow} DelayTime Sheet`,
                  null,
                  {
                    timeOut: 3000,
                  }
                );
                this.excelFile = [];
                this.WOTypeMasterData = [];
                this.FailureModeMasterData = [];
                this.PriorityMasterData = [];
                this.DelayTimeMasterData = [];
                return;
              } else TimeData.TimeLimit = obj['Delay Time / min'];
            } else {
              this.toaster.error(
                `Plant ${obj['Plant']} not found in database on row ${DTRow} DelayTime Sheet`,
                null,
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.WOTypeMasterData = [];
              this.FailureModeMasterData = [];
              this.PriorityMasterData = [];
              this.DelayTimeMasterData = [];
              return;
            }
          } else {
            this.toaster.error(
              `Group ${obj['Group']} not found in database on row ${DTRow} DelayTime Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
            this.excelFile = [];
            this.WOTypeMasterData = [];
            this.FailureModeMasterData = [];
            this.PriorityMasterData = [];
            this.DelayTimeMasterData = [];
            return;
          }

          TimeData.CreatedAt = new Date();
          TimeData.CreatedBy = this.userSession?.userCode;

          if (DTRow != 1) {
            let existXLData = this.DelayTimeMasterData.find((dt: any) => {
              return dt.Group == TimeData.Group && dt.Plant == TimeData.Plant;
            });
          }
          if (!uniqueData && !existXLData)
            this.DelayTimeMasterData.push(TimeData);
        }
        DTRow++;
      }
    }

    if (
      this.excelFile &&
      this.excelFile.BreakdownConfiguration &&
      this.excelFile.BreakdownConfiguration.length
    ) {
      for (let obj of this.excelFile.BreakdownConfiguration) {
        if (!obj['Group']) {
          if (!obj['Group']) {
            this.toaster.error(
              `Group can't be empty on row ${BDRow} in Breakdown Configuration Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          this.TechnicianMasterData = [];
          this.BreakdownConfigurationMasterData = [];
          return;
        } else if (!obj['Plant']) {
          if (!obj['Plant']) {
            this.toaster.error(
              `Plant can't be empty on row ${BDRow} in Breakdown Configuration Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          this.TechnicianMasterData = [];
          this.BreakdownConfigurationMasterData = [];
          return;
        } else if (obj['MinorMin'] == null) {
          if (obj['MinorMin'] == null) {
            this.toaster.error(
              `MinorMin can't be empty on row ${BDRow} in Breakdown Configuration Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          this.TechnicianMasterData = [];
          this.BreakdownConfigurationMasterData = [];
          return;
        } else if (obj['MinorMin'] < 0) {
          if (obj['MinorMin'] < 0) {
            this.toaster.error(
              `MinorMin can't be negative on row ${BDRow} in Breakdown Configuration Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          this.TechnicianMasterData = [];
          this.BreakdownConfigurationMasterData = [];
          return;
        } else if (!obj['MinorMax']) {
          if (!obj['MinorMax']) {
            this.toaster.error(
              `MinorMax can't be empty on row ${BDRow} in Breakdown Configuration Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          this.TechnicianMasterData = [];
          this.BreakdownConfigurationMasterData = [];
          return;
        } else if (!obj['ModerateMin']) {
          if (!obj['ModerateMin']) {
            this.toaster.error(
              `ModerateMin can't be empty on row ${BDRow} in Breakdown Configuration Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          this.TechnicianMasterData = [];
          this.BreakdownConfigurationMasterData = [];
          return;
        } else if (!obj['ModerateMax']) {
          if (!obj['ModerateMax']) {
            this.toaster.error(
              `ModerateMax can't be empty on row ${BDRow} in Breakdown Configuration Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          this.TechnicianMasterData = [];
          this.BreakdownConfigurationMasterData = [];
          return;
        } else if (!obj['MajorMin']) {
          if (!obj['MajorMin']) {
            this.toaster.error(
              `MajorMin can't be empty on row ${BDRow} in Breakdown Configuration Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          this.TechnicianMasterData = [];
          this.BreakdownConfigurationMasterData = [];
          return;
        }
        // else if (!obj['MajorMax']) {
        //   if (!obj['MajorMax']) {
        //     this.toaster.error(
        //       `MajorMax can't be empty on row ${BDRow} in Breakdown Configuration Sheet`,
        //       null,
        //       {
        //         timeOut: 3000,
        //       }
        //     );
        //   }
        //   this.excelFile = [];
        //   this.WOTypeMasterData = [];
        //   this.FailureModeMasterData = [];
        //   this.PriorityMasterData = [];
        //   this.DelayTimeMasterData = [];
        //   this.TechnicianMasterData = [];
        //   this.BreakdownConfigurationMasterData = [];
        //   return;
        // }
        else if (
          typeof obj['MinorMin'] === 'number' &&
          (obj['MinorMin'] % 1 !== 0 || obj['MinorMin'] < 0) &&
          typeof obj['MinorMax'] === 'number' &&
          (obj['MinorMax'] % 1 !== 0 || obj['MinorMax'] < 0) &&
          typeof obj['ModerateMin'] === 'number' &&
          (obj['ModerateMin'] % 1 !== 0 || obj['ModerateMin'] < 0) &&
          typeof obj['ModerateMax'] === 'number' &&
          (obj['ModerateMax'] % 1 !== 0 || obj['ModerateMax'] < 0) &&
          typeof obj['MajorMin'] === 'number' &&
          (obj['MajorMin'] % 1 !== 0 || obj['MajorMin'] < 0)
          // && typeof obj['MajorMax'] === 'number' &&
          // (obj['MajorMax'] % 1 !== 0 || obj['MajorMax'] < 0)
        ) {
          if (
            typeof obj['MinorMin'] === 'number' &&
            (obj['MinorMin'] % 1 !== 0 || obj['MinorMin'] < 0) &&
            typeof obj['MinorMax'] === 'number' &&
            (obj['MinorMax'] % 1 !== 0 || obj['MinorMax'] < 0) &&
            typeof obj['ModerateMin'] === 'number' &&
            (obj['ModerateMin'] % 1 !== 0 || obj['ModerateMin'] < 0) &&
            typeof obj['ModerateMax'] === 'number' &&
            (obj['ModerateMax'] % 1 !== 0 || obj['ModerateMax'] < 0) &&
            typeof obj['MajorMin'] === 'number' &&
            (obj['MajorMin'] % 1 !== 0 || obj['MajorMin'] < 0)
            // && typeof obj['MajorMax'] === 'number' &&
            // (obj['MajorMax'] % 1 !== 0 || obj['MajorMax'] < 0)
          ) {
            this.toaster.error(
              `Values at ${BDRow} in Breakdown Configuration Sheet are either non numeric or less than equal to zero`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          this.TechnicianMasterData = [];
          this.BreakdownConfigurationMasterData = [];
          return;
        } else if (obj['ModerateMin'] !== obj['MinorMax'] + 1) {
          if (obj['ModerateMin'] !== obj['MinorMax'] + 1) {
            this.toaster.error(
              `Moderate Min on row ${BDRow} in Breakdown Configuration Sheet should be in sequence order based on previous value`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          this.TechnicianMasterData = [];
          this.BreakdownConfigurationMasterData = [];
          return;
        } else if (obj['MajorMin'] !== obj['ModerateMax'] + 1) {
          if (obj['MajorMin'] !== obj['ModerateMax'] + 1) {
            this.toaster.error(
              `Major Min on row ${BDRow} in Breakdown Configuration Sheet should be in sequence order based on previous value`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          this.TechnicianMasterData = [];
          this.BreakdownConfigurationMasterData = [];
          return;
        } else if (
          obj['ModerateMin'] === obj['MinorMax'] + 1 &&
          obj['ModerateMax'] + 1 === obj['MajorMin']
        ) {
          let groupobj: any;
          let plantobj: any;
          let uniqueDataMinorMin: any;
          let uniqueDataMinorMax: any;
          let uniqueDataModerateMin: any;
          let uniqueDataModerateMax: any;
          let uniqueDataMajorMin: any;
          // let uniqueDataMajorMax: any;
          let existXLData: any;

          const BDData: any = {
            Group: this.groupSession?.groupCode,
            Plant: this.plantSession?.plantCode,
            MinorMin: '',
            MinorMax: '',
            ModerateMin: '',
            ModerateMax: '',
            MajorMin: '',
            // MajorMax: '',
            EffectiveEndDate: new Date(),
            CreatedAt: '',
            CreatedBy: '',
          };

          if (
            this.groupSession?.groupName.trim().toLowerCase() ===
            obj['Group'].trim().toLowerCase()
          ) {
            if (
              this.plantSession?.plantName.trim().toLowerCase() ===
              obj['Plant'].trim().toLowerCase()
            ) {
              uniqueDataMinorMin = this.AllBreakDown.find((bd: any) => {
                const a = obj['MinorMin'];
                const b = bd.MinorMin;
                return (
                  bd.Group &&
                  bd.Group.egId == BDData.Group &&
                  bd.Plant &&
                  bd.Plant.ptId == BDData.Plant &&
                  a == b
                );
              });
              if (!uniqueDataMinorMin) BDData.MinorMin = obj['MinorMin'];
              uniqueDataMinorMax = this.AllBreakDown.find((bd: any) => {
                const a = obj['MinorMax'];
                const b = bd.MinorMax;
                return (
                  bd.Group &&
                  bd.Group.egId == BDData.Group &&
                  bd.Plant &&
                  bd.Plant.ptId == BDData.Plant &&
                  a == b
                );
              });
              if (!uniqueDataMinorMax) BDData.MinorMax = obj['MinorMax'];

              uniqueDataModerateMin = this.AllBreakDown.find((bd: any) => {
                const a = obj['ModerateMin'];
                const b = bd.ModerateMin;
                return (
                  bd.Group &&
                  bd.Group.egId == BDData.Group &&
                  bd.Plant &&
                  bd.Plant.ptId == BDData.Plant &&
                  a == b
                );
              });
              if (!uniqueDataModerateMin)
                BDData.ModerateMin = obj['ModerateMin'];
              uniqueDataModerateMax = this.AllBreakDown.find((bd: any) => {
                const a = obj['ModerateMax'];
                const b = bd.ModerateMax;
                return (
                  bd.Group &&
                  bd.Group.egId == BDData.Group &&
                  bd.Plant &&
                  bd.Plant.ptId == BDData.Plant &&
                  a == b
                );
              });
              if (!uniqueDataModerateMax)
                BDData.ModerateMax = obj['ModerateMax'];

              uniqueDataMajorMin = this.AllBreakDown.find((bd: any) => {
                const a = obj['MajorMin'];
                const b = bd.MajorMin;
                return (
                  bd.Group &&
                  bd.Group.egId == BDData.Group &&
                  bd.Plant &&
                  bd.Plant.ptId == BDData.Plant &&
                  a == b
                );
              });
              if (!uniqueDataMajorMin) BDData.MajorMin = obj['MajorMin'];
              // uniqueDataMajorMax = this.AllBreakDown.find((bd: any) => {
              //   const a = obj['MajorMax'];
              //   const b = bd.MajorMax;
              //   return (
              //     bd.Group &&
              //     bd.Group.egId == BDData.Group &&
              //     bd.Plant &&
              //     bd.Plant.ptId == BDData.Plant &&
              //     a == b
              //   );
              // });
              // if (!uniqueDataMajorMax) BDData.MajorMax = obj['MajorMax'];
            } else {
              this.toaster.error(
                `Plant ${obj['Plant']} not found in database on row ${BDRow} in Breakdown Configuration Sheet`,
                null,
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.BreakdownConfigurationMasterData = [];
              return;
            }
          } else {
            this.toaster.error(
              `Group ${obj['Group']} not found in database on row ${BDRow} in Breakdown Configuration Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
            this.excelFile = [];
            this.BreakdownConfigurationMasterData = [];
            return;
          }

          BDData.CreatedAt = new Date();
          BDData.CreatedBy = this.userSession?.userCode;

          if (BDRow != 1) {
            existXLData = this.BreakdownConfigurationMasterData.find(
              (wo: any) => {
                return (
                  wo.Name == BDData.Name &&
                  wo.Group == BDData.Group &&
                  wo.Plant == BDData.Plant
                );
              }
            );
          }
          if (
            !uniqueDataMinorMin &&
            !uniqueDataMinorMax &&
            !uniqueDataModerateMin &&
            !uniqueDataModerateMax &&
            !uniqueDataMajorMin &&
            // !uniqueDataMajorMax &&
            !existXLData
          )
            this.BreakdownConfigurationMasterData.push(BDData);
        }
        BDRow++;
      }
    }

    if (
      this.excelFile &&
      this.excelFile.Technician &&
      this.excelFile.Technician.length
    ) {
      for (let obj of this.excelFile.Technician) {
        if (!obj['Group']) {
          if (!obj['Group']) {
            this.toaster.error(
              `Group can't be empty on row ${TechRow} in Technician Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          this.TechnicianMasterData = [];
          this.BreakdownConfigurationMasterData = [];
          return;
        } else if (!obj['Plant']) {
          if (!obj['Plant']) {
            this.toaster.error(
              `Plant can't be empty on row ${TechRow} in Technician Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          this.TechnicianMasterData = [];
          this.BreakdownConfigurationMasterData = [];
          return;
        } else if (!obj['User Name']) {
          if (!obj['User Name']) {
            this.toaster.error(
              `User Name can't be empty on row ${TechRow} in Technician Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          this.TechnicianMasterData = [];
          this.BreakdownConfigurationMasterData = [];
          return;
        } else {
          let groupobj: any;
          let plantobj: any;
          let checkgrppnt: any;
          let uniqueData: any;
          let existXLData: any;
          let existXLTech: any;
          const TechnicianData: any = {
            Data: { ID: 0, RMPM: 'RM', Name: [], CreatedAt: '', CreatedBy: '' },
            HeaderData: {
              Group: this.groupSession?.groupCode,
              Plant: this.plantSession?.plantCode,
            },
          };

          if (
            this.groupSession?.groupName.trim().toLowerCase() ===
            obj['Group'].trim().toLowerCase()
          ) {
            if (
              this.plantSession?.plantName.trim().toLowerCase() ===
              obj['Plant'].trim().toLowerCase()
            ) {
              const userobj = this.orgUserList.find(
                (employee) =>
                  employee.fullName.trim().toLowerCase().replace(/\s+/g, ' ') ===
                  obj['User Name'].trim().toLowerCase().replace(/\s+/g, ' ')
              );
              if (userobj) {
                let techobj = this.TechnicianList.find((tech: any) => {
                  const a = tech.UserId;
                  const b = userobj.employeeCode;
                  return a == b;
                });
                if (!techobj) {
                  if (TechRow != 1) {
                    let existXLData = this.TechnicianMasterData.find(
                      (tech: any) => {
                        return (
                          tech.HeaderData.Plant ==
                          TechnicianData.HeaderData.Plant
                        );
                      }
                    );
                    if (existXLData) {
                      existXLTech = existXLData.Data.Name.find(
                        (techID: any) => {
                          return techID == userobj.employeeCode;
                        }
                      );
                    }
                    checkgrppnt = this.TechnicianMasterData.find(
                      (grppnt: any) => {
                        return (
                          TechnicianData.HeaderData.Group ==
                          grppnt.HeaderData.Group &&
                          TechnicianData.HeaderData.Plant ==
                          grppnt.HeaderData.Plant
                        );
                      }
                    );
                    if (checkgrppnt) {
                      checkgrppnt.Data.Name.push(userobj.employeeCode);
                    } else {
                      TechnicianData.Data.Name.push(userobj.employeeCode);
                    }
                  } else {
                    TechnicianData.Data.Name.push(userobj.employeeCode);
                  }
                } else {
                  if (
                    techobj.Plant &&
                    techobj.Plant.ptId == TechnicianData.HeaderData.Plant
                  ) {
                    if (TechRow != 1) {
                      let existXLData = this.TechnicianMasterData.find(
                        (tech: any) => {
                          return (
                            tech.HeaderData.Plant ==
                            TechnicianData.HeaderData.Plant
                          );
                        }
                      );
                      if (existXLData) {
                        let existXLTech = existXLData.Data.Name.find(
                          (techID: any) => {
                            return techID == userobj.employeeCode;
                          }
                        );
                      }
                      checkgrppnt = this.TechnicianMasterData.find(
                        (grppnt: any) => {
                          return (
                            TechnicianData.HeaderData.Group ==
                            grppnt.HeaderData.Group &&
                            TechnicianData.HeaderData.Plant ==
                            grppnt.HeaderData.Plant
                          );
                        }
                      );
                      if (checkgrppnt) {
                        checkgrppnt.Data.Name.push(userobj.employeeCode);
                      } else {
                        TechnicianData.Data.Name.push(userobj.employeeCode);
                      }
                    } else {
                      TechnicianData.Data.Name.push(userobj.employeeCode);
                    }
                  } else {
                  }
                }
              } else {
                this.toaster.error(
                  `User Name ${obj['User Name']} not found in database on row ${TechRow} in Technician Sheet`,
                  null,
                  {
                    timeOut: 3000,
                  }
                );
                this.excelFile = [];
                this.WOTypeMasterData = [];
                this.FailureModeMasterData = [];
                this.PriorityMasterData = [];
                this.DelayTimeMasterData = [];
                this.TechnicianMasterData = [];
                this.BreakdownConfigurationMasterData = [];
                return;
              }
            } else {
              this.toaster.error(
                `Plant ${obj['Plant']} not found in database on row ${TechRow} in Technician Sheet`,
                null,
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.WOTypeMasterData = [];
              this.FailureModeMasterData = [];
              this.PriorityMasterData = [];
              this.DelayTimeMasterData = [];
              this.TechnicianMasterData = [];
              this.BreakdownConfigurationMasterData = [];
              return;
            }
          } else {
            this.toaster.error(
              `Group ${obj['Group']} not found in database on row ${TechRow} in Technician Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
            this.excelFile = [];
            this.WOTypeMasterData = [];
            this.FailureModeMasterData = [];
            this.PriorityMasterData = [];
            this.DelayTimeMasterData = [];
            this.TechnicianMasterData = [];
            this.BreakdownConfigurationMasterData = [];
            return;
          }

          TechnicianData.Data.CreatedAt = new Date();
          TechnicianData.Data.CreatedBy = this.userSession?.userCode;
          if ((TechRow == 1 || !checkgrppnt) && !existXLTech)
            this.TechnicianMasterData.push(TechnicianData);
        }
        TechRow++;
      }
    }

    this.MasterRMDataOnSubmit();
  }

  validateExcelDataforFailure() {
    var FMRow = 1;
    if (
      this.excelFile &&
      this.excelFile.FailureMode &&
      this.excelFile.FailureMode.length
    ) {
      for (let obj of this.excelFile.FailureMode) {
        if (!obj['Group']) {
          if (!obj['Group']) {
            this.toaster.error(
              `Group can't be empty on row ${FMRow} in Failure Mode Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          return;
        } else if (!obj['Plant']) {
          if (!obj['Plant']) {
            this.toaster.error(
              `Plant can't be empty on row ${FMRow} in Failure Mode Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          return;
        } else if (!obj['Failure Mode Name']) {
          if (!obj['Failure Mode Name']) {
            this.toaster.error(
              `Failure Mode Name can't be empty on row ${FMRow} in Failure Mode Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          return;
        } else if (!obj['Work Order Type']) {
          if (!obj['Work Order Type']) {
            this.toaster.error(
              `Work Order Type can't be empty on row ${FMRow} in Failure Mode Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
          }
          this.excelFile = [];
          this.WOTypeMasterData = [];
          this.FailureModeMasterData = [];
          return;
        } else {
          let groupobj: any;
          let plantobj: any;
          let woType: any;
          let uniqueData: any;
          let existXLData: any;

          const FailureModeData: any = {
            Group: this.groupSession?.groupCode,
            Plant: this.plantSession?.plantCode,
            Name: '',
            WOType: '',
            CreatedAt: '',
            CreatedBy: '',
          };

          if (
            this.groupSession?.groupName.trim().toLowerCase() ===
            obj['Group'].trim().toLowerCase()
          ) {
            if (
              this.plantSession?.plantName.trim().toLowerCase() ===
              obj['Plant'].trim().toLowerCase()
            ) {
              uniqueData = this.AllFailureMode.find((fm: any) => {
                const a = obj['Failure Mode Name'].trim().toLowerCase();
                const b = fm.Name.trim().toLowerCase();
                return (
                  fm.Group &&
                  fm.Group.egId == FailureModeData.Group &&
                  fm.Plant &&
                  fm.Plant.ptId == FailureModeData.Plant &&
                  a == b
                );
              });
              if (!uniqueData) {
                woType = this.WOTypeList.find((wo: any) => {
                  const a = obj['Work Order Type'].trim().toLowerCase();
                  const b = wo.Name.trim().toLowerCase();
                  return a == b;
                });
                if (woType) {
                  FailureModeData.Name = obj['Failure Mode Name'];
                  FailureModeData.WOType = woType.ID;
                } else {
                  this.toaster.error(
                    `Work Order Type ${obj['Work Order Type']} not found in database on row ${FMRow} in Failure Mode Sheet`,
                    null,
                    {
                      timeOut: 3000,
                    }
                  );
                  this.excelFile = [];
                  this.WOTypeMasterData = [];
                  this.FailureModeMasterData = [];
                  return;
                }
              } else {
                this.toaster.error(
                  `Failure Mode ${obj['Failure Mode Name']} already exist on row ${FMRow} in Failure Mode Sheet`,
                  null,
                  {
                    timeOut: 3000,
                  }
                );
                this.excelFile = [];
                this.WOTypeMasterData = [];
                this.FailureModeMasterData = [];
                return;
              }
            } else {
              this.toaster.error(
                `Plant ${obj['Plant']} not found in database on row ${FMRow} in Failure Mode Sheet`,
                null,
                {
                  timeOut: 3000,
                }
              );
              this.excelFile = [];
              this.WOTypeMasterData = [];
              this.FailureModeMasterData = [];
              return;
            }
          } else {
            this.toaster.error(
              `Group ${obj['Group']} not found in database on row ${FMRow} in Failure Mode Sheet`,
              null,
              {
                timeOut: 3000,
              }
            );
            this.excelFile = [];
            this.WOTypeMasterData = [];
            this.FailureModeMasterData = [];
            return;
          }

          FailureModeData.CreatedAt = new Date();
          FailureModeData.CreatedBy = this.userSession?.userCode;

          if (FMRow != 1) {
            existXLData = this.FailureModeMasterData.find((fm: any) => {
              return (
                fm.Name == FailureModeData.Name &&
                fm.Group == FailureModeData.Group &&
                fm.Plant == FailureModeData.Plant
              );
            });
          }
          if (!uniqueData && !existXLData)
            this.FailureModeMasterData.push(FailureModeData);
        }
        FMRow++;
      }
    }
  }

  MasterRMDataOnSubmit() {
    if (
      this.WOTypeMasterData &&
      this.WOTypeMasterData.length == 0 &&
      this.PriorityMasterData &&
      this.PriorityMasterData.length == 0 &&
      this.DelayTimeMasterData &&
      this.DelayTimeMasterData.length == 0 &&
      (this.TechnicianMasterData && this.TechnicianMasterData.length) == 0 &&
      (this.BreakdownConfigurationMasterData &&
        this.BreakdownConfigurationMasterData.length) == 0
    ) {
      this.toaster.warning('Please Fill The Sheets');
      return false;
    }
    this.spinnerText = 'Creating RM Master Data';
    this.spinner.show();
    if (this.WOTypeMasterData && this.WOTypeMasterData.length)
      this.WOTypeMasterData.map((row: any) => (row.RMPM = 'RM'));
    let data = {
      WOTypeMasterData: this.WOTypeMasterData,
      FailureModeMasterData: [],
      PriorityMasterData: this.PriorityMasterData,
      DelayTimeMasterData: this.DelayTimeMasterData,
      TechnicianMasterData: this.TechnicianMasterData,
      BreakdownConfigurationMasterData: this.BreakdownConfigurationMasterData,
    };
    this.RMConfigurationService.RMMasterUpload(data).subscribe(
      (res: any) => {
        this.edited = false;
        if (res.status) {
          this.getWOType();
          this.getAllPriority();
          this.getTime();
          this.getAllTechnician();
          this.getBreakdown();
          this.WOTypeMasterData = [];
          this.PriorityMasterData = [];
          this.DelayTimeMasterData = [];
          this.TechnicianMasterData = [];
          this.BreakdownConfigurationMasterData = [];
          setTimeout(() => {
            this.validateExcelDataforFailure();
            if (
              this.FailureModeMasterData &&
              this.FailureModeMasterData.length > 0
            ) {
              let dataFailure = {
                FailureModeMasterData: this.FailureModeMasterData,
                WOTypeMasterData: [],
                PriorityMasterData: [],
                DelayTimeMasterData: [],
                TechnicianMasterData: [],
                BreakdownConfigurationMasterData: [],
              };
              this.RMConfigurationService.RMMasterUpload(dataFailure).subscribe(
                (res: any) => {
                  this.toaster.success(res.message);
                  this.getFailureMode();
                  this.excelFile = [];
                  this.WOTypeMasterData = [];
                  this.FailureModeMasterData = [];
                  this.PriorityMasterData = [];
                  this.DelayTimeMasterData = [];
                  this.TechnicianMasterData = [];
                  this.BreakdownConfigurationMasterData = [];
                  this.spinner.hide();
                },
                (error: any) => {
                  this.excelFile = [];
                  this.WOTypeMasterData = [];
                  this.FailureModeMasterData = [];
                  this.PriorityMasterData = [];
                  this.DelayTimeMasterData = [];
                  this.TechnicianMasterData = [];
                  this.BreakdownConfigurationMasterData = [];
                  this.spinner.hide();
                  this.toaster.error(error.message);
                }
              );
            }
            else {
              this.toaster.success(res.message);
            }
            this.excelFile = [];
          }, 3000);
        }
        this.spinner.hide();
      },
      (error: any) => {
        this.excelFile = [];
        this.WOTypeMasterData = [];
        this.FailureModeMasterData = [];
        this.PriorityMasterData = [];
        this.DelayTimeMasterData = [];
        this.TechnicianMasterData = [];
        this.BreakdownConfigurationMasterData = [];
        this.spinner.hide();
        this.toaster.error(error.message);
      }
    );
  }

  tableDataSetWOType(data: any) {
    this.WOTypeDataSource = new MatTableDataSource(data);
    this.getPaginator(this.WOTypeDataSource, 0);
  }

  tableDataSetWPType(data: any) {
    this.WPTypeDataSource = new MatTableDataSource(data);
    this.getPaginator(this.WPTypeDataSource, 0);
  }

  tableDataSetBreakdownConfiguration(data: any) {
    this.breakDownConfigurationDataSource = new MatTableDataSource(data);
    this.getPaginator(this.breakDownConfigurationDataSource, 0);
  }

  tableDataSetPriority(data: any) {
    this.PrioritySource = new MatTableDataSource(data);
    this.getPaginator(this.PrioritySource, 2);
  }
  closeaddNewPlantItemModel(): void {
    this.displayComponentModal = false;
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  SelectVarUnitName(unitname: any): any {
    if (unitname.title === 'UNT') {
      this.varUnitName = unitname.name;
      this.isPlantGroupModelVisible = false;
    }
  }

  resetForm(form: FormGroup, value: any) {
    form.get(value)?.setValue('');
  }
  getTextColor(backgroundColor: string): string {
    return this.isColorBright(backgroundColor) ? 'black' : 'white';
  }

  isColorBright(hexColor: string): boolean {
    const r = parseInt(hexColor?.slice(1, 3), 16);
    const g = parseInt(hexColor?.slice(3, 5), 16);
    const b = parseInt(hexColor?.slice(5, 7), 16);
    const brightness = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    return brightness > 0.5;
  }

  reset() {
    this.edited = false;
    this.isEdit = false;
  }
  onSubmitBreakdownForm(formDirective: FormGroupDirective) {
    if (!this.breakdownForm.valid)
      this.toaster.warning('Please Fill All Required Fields');
    else {
      const hasPointValue = Object.values(this.breakdownForm.value).some(
        (value) => typeof value === 'number' && (value % 1 !== 0 || value < 0)
      );
      if (hasPointValue) {
        this.toaster.warning(
          'Negative and decimal values are not allowed.'
        );
        return;
      }

      let MinorMin = this.breakdownForm.get('minorMin').value;
      let MinorMax = this.breakdownForm.get('minorMax').value;
      let ModerateMin = this.breakdownForm.get('moderateMin').value;
      let ModerateMax = this.breakdownForm.get('moderateMax').value;
      let MajorMin = this.breakdownForm.get('majorMin').value;
      // let MajorMax = this.breakdownForm.get('majorMax').value;

      if (MinorMin === null && MinorMax) {
        this.breakdownForm.get('minorMin').setValue(MinorMax - 1);
        MinorMin = this.breakdownForm.get('minorMin').value;
      }
      // if (MajorMin && MajorMax === null) {
      //   this.breakdownForm.get('majorMax').setValue(MajorMin + 1);
      //   MajorMax = this.breakdownForm.get('majorMax').value;
      // }

      let errorMessage = '';

      if (MinorMax <= MinorMin) {
        errorMessage += 'Minor Min should be less than Minor Max. ';
      }

      if (ModerateMin <= MinorMax) {
        errorMessage += 'Moderate Min should be greater than Minor Max. ';
      }

      if (ModerateMax <= ModerateMin) {
        errorMessage += 'Moderate Max should be greater than Moderate Min. ';
      }

      if (MajorMin <= ModerateMax) {
        errorMessage += 'Major Min should be greater than Moderate Max. ';
      }

      // if (MajorMax <= MajorMin) {
      //   errorMessage += 'Major Max should be greater than Major Min. ';
      // }

      if (ModerateMin !== MinorMax + 1) errorMessage = 'Moderate Min should be in sequence order based on previous value.';

      if (MajorMin !== ModerateMax + 1) errorMessage = 'Major Min should be in sequence order based on previous value.';

      if (errorMessage) {
        this.toaster.warning(errorMessage);
        return;
      }
      if (ModerateMin === MinorMax + 1 && ModerateMax + 1 === MajorMin) {
        this.formDirective = formDirective;
        const key = {
          Id: this.breakdownForm.get('id').value || 0,
          GroupId: this.groupSession?.groupCode,
          PlantId: this.plantSession?.plantCode,
          MinorMin: this.breakdownForm.get('minorMin').value,
          MinorMax: this.breakdownForm.get('minorMax').value,
          ModerateMin: this.breakdownForm.get('moderateMin').value,
          ModerateMax: this.breakdownForm.get('moderateMax').value,
          MajorMin: this.breakdownForm.get('majorMin').value,
          // MajorMax: this.breakdownForm.get('majorMax').value,
          EffectiveEndDate: new Date(),
        };
        if (!this.isBreakdownEdit) {
          this.spinner.show();
          this.RMConfigurationService.onSubmitBreakdown(key).subscribe(
            (res: any) => {
              if (res.status) {
                this.toaster.success(res.message);
              }
              this.spinner.hide();
              this.formDirective.resetForm();
              this.getBreakdown();
            },
            (error: any) => {
              this.spinner.hide();
              this.toaster.error(error.message);
            }
          );
        } else {
          this.spinner.show();
          this.RMConfigurationService.onUpdateBreakdown(key).subscribe(
            (res: any) => {
              if (res.status) {
                this.toaster.success(res.message);
              }
              this.spinner.hide();
              this.isBreakdownEdit = false;
              this.formDirective.resetForm();
              this.getBreakdown();
            },
            (error: any) => {
              this.isBreakdownEdit = false;
              this.spinner.hide();
              this.toaster.error(error.message);
            }
          );
        }
      }
    }
  }

  onSubmitWorkPermitForm(formDirective: FormGroupDirective) {
    if (this.workPermitForm.invalid) {
      this.toaster.warning('Please Fill All Required Fields');
      return;
    } else {
      this.formDirective = formDirective;
      this.WorkPermit.CreatedAt = new Date();
      this.WorkPermit.CreatedBy = this.userSession?.userCode;
      const dataGroupPlant = {
        Group: this.groupSession?.groupCode,
        Plant: this.plantSession?.plantCode,
      };
      const data = {
        Data: this.WorkPermit,
        HeaderData: dataGroupPlant,
      };

      const tableHardCodedData = {
        Id: this.WorkPermit.Id,
        WorkPermitRequired: this.WorkPermit.wpRequired ? true : false,
        WorkPermitRequest: this.WorkPermit.wpRequest,
        CreatedAt: this.WorkPermit.CreatedAt,
        CreatedBy: this.WorkPermit.CreatedBy,
      };
      if (!this.isEdit) {
        this.WPTypeList.push(tableHardCodedData);
        this.toaster.success('Added Successful');
      }
      if (this.isEdit) {
        this.WPTypeList.length = 0;
        this.WPTypeList.push(tableHardCodedData);
        this.toaster.success('Updated Successful');
      }
      if (this.WPTypeList.length == 1) {
        this.tableDataSetWPType(this.WPTypeList);
        this.WPTypePage.length = this.WPTypeList.length;
        this.workPermitForm.reset();
      }
      else {
        this.toaster.warning('You can insert only one work permit');
      }

      if (!this.edited) {
        const chkWorkPermit = this.WPTypeList.find((pm: any) => {
          const a = pm.WorkPermitRequest.toLowerCase();
          const b = this.WPTypeList.WorkPermitRequest.toLowerCase();
          return a == b && this.WPTypeList.WOType == pm.WOType.ID;
        });
        if (chkWorkPermit) {
          this.toaster.warning('This Work Permit Already Exist');
          return;
        }

        // this.RMConfigurationService.addFailureMode(data).subscribe(
        //   (res: any) => {
        //     this.spinner.hide();
        //     this.formDirective.resetForm();
        //     this.FailureModeForm.reset();
        //     this.edited = false;
        //     if (res.status) {
        //       this.toaster.success(res.message, 'Success');
        //       this.getFailureMode();
        //     }
        //   },
        //   (error: any) => {
        //     this.spinner.hide();
        //     this.toaster.error('Error', error.message);
        //   }
        // );
      } else {
        const chkWorkPermit = this.WPTypeList.find(
          (x) =>
            x.WorkPermitRequest.toLowerCase() ===
            this.WPTypeList.WorkPermitRequest.toLowerCase()
        );

        if (chkWorkPermit) {
          this.toaster.warning('This Work Permit Already Exist');
          return;
        }
        // this.RMConfigurationService.updateFailureMode(data).subscribe(
        //   (res: any) => {
        //     this.spinner.hide();
        //     this.formDirective.resetForm();
        //     this.workPermitForm.reset();
        //     this.edited = false;
        //     if (res.status) {
        //       this.toaster.success(res.message, 'Success');
        //       this.getFailureMode();
        //     }
        //   },
        //   (error: any) => {
        //     this.spinner.hide();
        //     this.toaster.error('Error', error.message);
        //   }
        // );
      }
      this.formDirective.resetForm();
      this.workPermitForm.reset();
    }
  }

  onClickEdit(event: any) {
    if (!this.permissionService.isUserHasPermission(this.isUpdate)) {
      this.toaster.warning('You donot Have the permission');
      return;
    }
    this.isBreakdownEdit = true;
    const data = event.data;
    this.breakdownForm.patchValue({
      id: data.Id,
      minorMin: data.MinorMin,
      minorMax: data.MinorMax,
      moderateMin: data.ModerateMin,
      moderateMax: data.ModerateMax,
      majorMin: data.MajorMin,
      // majorMax: data.MajorMax,
    });
  }

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.headerName;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }
}
